import {combineReducers} from 'redux';
import {loading, loadingIds} from './loading';
import api from '../services/Api/reducers/index';
import appFrame from '../scenes/AppFrame/reducer';
import {reducer as notifications} from 'react-notification-system-redux'

export default combineReducers({

    loading,
    loadingIds,
    api,
    appFrame,
    notifications

})



// WEBPACK FOOTER //
// ./src/App/reducers/index.js